// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-time[data-v-ec5c0ea8] .multiselect__placeholder{color:#000}.cart-time[data-v-ec5c0ea8] .multiselect__tags{color:var(--red);background-color:var(--warning)}", ""]);
// Exports
module.exports = exports;
